export default "__VITE_ASSET__Ce3H$yot__"